import axios from "axios"
import authAxios from "./axios-instance/authAxios";

const mainApiHost = process.env.REACT_APP_MAIN_API_HOST;

export function LinkCategoriesApi(props) {
    return {
        searchListByUserPageId: async ({ params, headers }) => {
            return await axios.get(`${mainApiHost}/link-categories/user-pages/${params?.userPageId}`, {
                headers: headers
            })
        },
        createOne: async ({ body, headers }) => {
            return await authAxios.post(`${mainApiHost}/link-categories`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        deleteOne: async ({ body, headers }) => {
            return await authAxios.delete(`${mainApiHost}/link-categories`, {
                data: body,
                headers: headers,
                withCredentials: true
            })
        },
        changeOne_name: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/link-categories/one/name`, body, {
                headers: headers,
                withCredentials: true
            })
        },
        changeList_orderNumber: async ({ body, headers }) => {
            return await authAxios.patch(`${mainApiHost}/link-categories/list/orderNumber`, body, {
                headers: headers,
                withCredentials: true
            })
        }
    }
}